import type { ReactElement, ReactNode } from 'react';
import { SentryErrorBoundary } from '@/lib/sentry';

interface FeatureErrorBoundaryProps {
  name: string;
  children: ReactNode;
  fallback?: ReactElement;
  silent?: boolean;
}

function FeatureFallback({ name }: { name: string }) {
  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 p-2 text-xs text-amber-800">
      Фича «{name}» временно недоступна. Перезагрузите страницу или попробуйте позже.
    </div>
  );
}

export function FeatureErrorBoundary({
  name,
  children,
  fallback,
  silent = false,
}: FeatureErrorBoundaryProps) {
  const fb: ReactElement = silent ? <></> : (fallback ?? <FeatureFallback name={name} />);
  return (
    <SentryErrorBoundary
      fallback={fb}
      beforeCapture={(scope) => {
        scope.setTag('feature', name);
      }}
    >
      {children}
    </SentryErrorBoundary>
  );
}
